/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
export default {
  props: {
    status: [String, Number],
    isUse: [String, Number],
    isReal: [String, Number]
  },
  components: {},
  computed: {
    statusObj: function statusObj() {
      //订单状态（订单状态：0 交易成功；1 待付款；2 已取消；3 已关闭；4 已关闭（有退款）；5 待发货；6 已发货；7 已发货（退款申请中）；8 退款完成；9 已发货（退款已拒绝）;10 系统自动取消-->前端显示已关闭）
      var statusList = [{
        name: '交易成功',
        color: '#02C85A'
      }, {
        name: '待付款',
        color: '#F8A039'
      }, {
        name: '已取消',
        color: '#999999'
      }, {
        name: '已关闭',
        color: '#999999'
      }, {
        name: '已关闭（有退款）',
        color: '#999999'
      }, {
        name: '待发货',
        color: '#F8A039'
      }, {
        name: '卖家已发货',
        color: '#3998F8'
      }, {
        name: '退款申请中',
        color: '#F8A039 '
      }, {
        name: '退款完成',
        color: '#02C85A'
      }, {
        name: '退款已拒绝',
        color: '#F13E3E'
      }, {
        name: '已关闭',
        color: '#999999'
      }];
      var useList = [{
        name: '未使用',
        color: '#02C85A'
      }, {
        name: '已使用',
        color: '#F8A039'
      }];
      console.log('orderTop:  ');
      console.log(this.status);
      console.log(this.isUse);
      var index = parseInt(this.status),
          index2;
      var obj = {};

      if (this.isReal == 1) {
        index = parseInt(this.status);
        obj = {
          index: index,
          name: statusList[index].name,
          color: statusList[index].color
        };
      } else if (this.isReal == 0) {
        index2 = parseInt(this.isUse);

        if (index == 0) {
          obj = {
            index: index2,
            name: useList[index2].name,
            color: useList[index2].color
          };
        } else {
          obj = {
            index: index,
            name: statusList[index].name,
            color: statusList[index].color
          };
        }
      }

      return obj;
    }
  },
  data: function data() {
    return {};
  },
  created: function created() {}
};